import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { appInsights } from './telemetry/appInsights';

// Track initial page view
if (process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING) {
  appInsights.trackPageView();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
